

angular
.module('inkfinder')
.factory('FormatProject', function FormatProject(
  FormatAppointment,
  _
) {
  // Public methods
  FormatProject.formatCollection = formatCollection;
  FormatProject.format = format;

  /**
   * @name formatCollection
   * @param {array} collection Array of appointments/projects objects to format.
   * @return {array} projectCollection Returns the array of formatted projects.
   */
  function formatCollection(collection) {
    let projectCollection = [];
    projectCollection = _.map(collection, (project) =>
      format(project));
    return projectCollection;
  }

  /**
   * @name format
   * @description Function to format the data of a Ink Finder project object
   * @param {object} project The project to format.
   * @return {object} formatted Returns the formatted project.
   */
  function format(project) {
    let formatted = project;

    // Reference, coverup, and completed images
    formatted.referenceImages = [];
    if (project.reference_images && project.reference_images.length) {
      formatted.referenceImage = project.reference_images[0].image_1024;
      _.each(project.reference_images, function(image) {
        image.type = 'reference';
        formatted.referenceImages.push({
          result: image,
          progress: 100
        });
      });
    }
    formatted.coverupImages = [];
    if (project.coverup_images && project.coverup_images.length) {
      _.each(project.coverup_images, function(image) {
        image.type = 'coverup';
        formatted.coverupImages.push({
          result: image,
          progress: 100
        });
      });
    }
    formatted.completedImages = [];
    if (project.completed_images && project.completed_images.length) {
      _.each(project.completed_images, function(image) {
        image.type = 'completed';
        formatted.completedImages.push({
          result: image,
          progress: 100
        });
      });
    }

    // Copy the original server data for coverup. Set the coverup description
    // to 'Yes' or 'No'
    if (project.coverup === true) {
      formatted.coverupDescription = 'Yes';
    } else {
      formatted.coverupDescription = 'No';
    }

    // Copy the origin server data for full_color. Set the color message to
    // 'Full color' or 'Black and gray'
    if (project.full_color === true) {
      formatted.colorDescription = 'Full color';
    } else {
      formatted.colorDescription = 'Black and gray';
    }

    // Format project appointments
    if (project.appointments && project.appointments.length > 0) {
      formatted.appointments =
      FormatAppointment.formatCollection(project.appointments);
    }
    return formatted;
  }
  return FormatProject;
});



// WEBPACK FOOTER //
// ./components/projects/util/format-projects.service.js